module.exports = __webpack_public_path__ + "static/media/WhatsApp Image 2020-01-31 at 7.35.54 PM.a7b95b4c.jpeg";